import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://kryqqbxjefaszgjcxlxp.supabase.co"
const supabaseKey = "sb_publishable_5pk9oCuSRsrBZ-t81Zwbfg_cbjfavYS"

// Create a single instance of the client to use everywhere
export const supabase = createClient(supabaseUrl, supabaseKey)
export const MY_BACKEND_URL = "https://ocul-server-1009583072068.asia-south1.run.app";
